import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomerDetailsComponent } from './restaurant-menu/checkout/customer-details/customer-details.component';
import { RestaurantMenuComponent } from './restaurant-menu/restaurant-menu.component';
import { OnlineOrderComponent } from './online-order.component';
import { CartComponent } from './restaurant-menu/cart/cart.component';
import { CheckoutComponent } from './restaurant-menu/checkout/checkout.component';
import { MyOrdersComponent } from './restaurant-menu/my-orders/my-orders.component';
import { OnlineOrderDetailsComponent } from './restaurant-menu/my-orders/online-order-details/online-order-details.component';
import { CustomerLoginComponent } from './restaurant-menu/customer-login/customer-login.component';


const routes: Routes = [
	{
		path: 'pedidos', component: OnlineOrderComponent
	},
	{
		path: 'pedidos/:restaurant_name', component: RestaurantMenuComponent
	},
	{
		path: 'pedidos/:restaurant_name/carrinho', component: CartComponent
	},
	{
		path: 'pedidos/:restaurant_name/checkout', component: CheckoutComponent
	},
	{
		path: 'pedidos/:restaurant_name/dados-cliente', component: CustomerDetailsComponent
	},
	{
		path: 'pedidos/:restaurant_name/entrar', component: CustomerLoginComponent
	},
	{
		path: 'pedidos/:restaurant_name/meus-pedidos', component: MyOrdersComponent
	},
	{
		path: 'pedidos/:restaurant_name/meus-pedidos/:online_order_id', component: OnlineOrderDetailsComponent
	}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OnlineOrderRoutingModule { }
